import React, { useEffect, useRef } from 'react'

import styles from './styles.module.scss'
import Actions from 'src/components/actionbar'
import { useDispatch } from 'react-redux'
import { invalidateOpportunities } from 'src/legacy/redux/actions/opportunities'
import InfiniteScroll from 'src/components/infiniteScroll'
import _ from 'lodash'
import { StreamPlaceholder } from 'src/components/entityBrowser'
import { useSelector } from 'react-redux'
import LinesEllipsis from 'react-lines-ellipsis'
import cx from 'classnames'
import { Link } from 'react-router-dom'
import { fetchIntegrations } from 'src/legacy/redux/actions/integrations'
import { fetchOpportunities, invalidateIntegrationOpportunities } from 'src/redux/actions/opportunities'

interface MapDealsProps {
  selectedOpportunity: string;
  isCRMIntegrated?: boolean;
  setSelectedOpportunity: (opportunity: string) => void;
}


const MapDeals: React.FC<MapDealsProps> = ({ selectedOpportunity, setSelectedOpportunity, isCRMIntegrated }) => {
  const dispatch: any = useDispatch();

  const [searchQuery, setSearchQuery] = React.useState<string>("");
  const user = useSelector((state) => _.get(state, "users.me", {}));

  const { loading, opportunities, nextPage, hasMore, offset } = useSelector((state: any) => {
    const opportunitiesState = _.get(state, 'opportunities');

    const loading = _.get(opportunitiesState, 'loading');
    const total = _.get(opportunitiesState, "pagination.totalPages", 0);
    const hasMoreItems = _.get(opportunitiesState, "pagination.currentPage", 0) < _.get(opportunitiesState, "pagination.totalPages", 0) - 1;
    const opportunities = _.get(opportunitiesState, 'items');
    let nextPage: number | null = _.get(opportunitiesState, "pagination.currentPage", 0) + 1;
    if (nextPage && nextPage >= total) {
      nextPage = null;
    }

    let offset = 0;

    if (opportunitiesState.pagination.nextPage > 0) {
      offset = opportunitiesState.pagination.nextPage;
    }


    return {
      loading: loading,
      opportunities: opportunities,
      nextPage: nextPage,
      hasMore: offset > 0 || hasMoreItems,
      offset: offset
    };
  });

  const [containsOpportunities, setContainsOpportunities] = React.useState(false);

  
  useEffect(() => {
    if (!loading) {
      if (_.size(opportunities) > 0) {
        setContainsOpportunities(true);
      }
    }
  }, [loading, opportunities]);


  useEffect(() => {
    dispatch(fetchIntegrations());
    if(!loading){
      dispatch(fetchOpportunities({
        query: "",
        page: 0
      }));
    }

    return () => {
      dispatch(invalidateOpportunities());
      setSelectedOpportunity("");
    }
  }, [])

  if (!loading && !isCRMIntegrated) {
    return (
      <div className={styles.emptyMessage}>
        <div>
          <img src="/images/kiteErrorMessage.svg" />
          <div className={styles.message}>
            <p> { _.get(user,"admin",false) ? "Almost there! To map a deal, connect your CRM via Settings → Integrations." : "To map an opportunity, connect your CRM. If you don't have access, contact your admin."} <br /> <Link target='_blank' className={styles.link} to="/settings/integrations">Connect your CRM</Link></p>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className={styles.mapDeals}>
      <p className={styles.subText}>
        {_.size(opportunities) > 0 && <span>Map Deal Room to an Opportunity</span>}
      </p>
      {containsOpportunities && <div className={styles.search}>
        <Actions.Search query={searchQuery} onSearch={(query) => {
          if(query === null){
            dispatch(invalidateIntegrationOpportunities());
          }
          setSearchQuery(query || "");
          if(!loading){
            dispatch(fetchOpportunities({
              query: query || "",
              page: 0
            }));
          }
        }} />
      </div>}

      <InfiniteScroll
        className={cx(styles.scroll, {
        [styles.createDealRoom]: window.location.pathname.includes("/deal-rooms"),
        })}
        loading={loading}
        hasMore={hasMore}
        loadMore={() => {
          if ((nextPage || offset) && !loading) {
            dispatch(fetchOpportunities({
              query: "",
              page: 0,
              nextPage: offset
            }));
          }
        }}
        loader={() => {
          return (
            <>
              {_.size(opportunities) === 0 && <>
                <StreamPlaceholder width={"50%"} />
                <StreamPlaceholder width={"70%"} />
                <StreamPlaceholder width={"60%"} />
                <StreamPlaceholder width={"50%"} />
              </>}

              {_.size(opportunities) > 0 && <>
                <StreamPlaceholder width={"70%"} />
              </>}
            </>
          );

        }}
      >
        {_.map(opportunities, (opportunity: any) => {

          const selected = selectedOpportunity === opportunity.id;
          return (
            <div className={cx(styles.entity, {
              [styles.selected]: selected
            })} onClick={() => {
              if (selected) {
                setSelectedOpportunity("");
                return;
              }
              setSelectedOpportunity(opportunity.id);
            }}>
              <div className={styles.name}>
                <LinesEllipsis text={opportunity.name || ""} maxLine='1' ellipsis="..." basedOn="letters" />
              </div>
              <div className={styles.actions}>
                <button className={styles.action}>
                  <i className={cx(styles.arrow, selected ? "paperflite-radio-button-selected" : "paperflite-radio-button-unselected")}></i>
                </button>
              </div>
            </div>
          )
        })}

        {!loading && _.size(opportunities) === 0 && (
          <div className={styles.empty}>
            No Active Opportunities to Map
          </div>
        )}
      </InfiniteScroll>


    </div>
  )
}

export default MapDeals